<template> 
    <v-dialog v-model="show" fullscreen hide-overlay transition="slide-y-transition"> <!-- dialog-bottom-transition -->
        <v-card class="page-card d-flex flex-column">
            <div>
                <v-toolbar flat fixed class="title-bar appbg" style="border-bottom: 1px solid rgba(0,0,0, 0.08)!important">
                        <v-toolbar-items v-if="icon" class="me-3">
                            <v-icon>
                                {{icon}}
                            </v-icon>
                        </v-toolbar-items>
                    
                        <div class="normal-text">
                            <span>{{title}}</span>
                        </div>
                        <v-spacer></v-spacer>
                        <div>
                            <slot name="header-actions" />
                            <v-btn v-haptic icon color="grey" @click.stop.prevent="show = false">
                                <!-- <v-icon>mdi-close</v-icon> -->
                                <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                        </div>
                    
                </v-toolbar>

            </div>
            <v-card-text class="content-wrapper d-flex flex-grow-1 px-3 pt-2 pb-3">

                <div class="d-flex flex-column flex-grow-1 content-container" style="max-width: 100%;">
                    <slot />
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        icon: {},
        title: {},
        value: {},
    },
    data(){
        return {
            show: false,
        }
    },
    computed: {
        ...GlobalComputed
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    methods: {
        
        ...GlobalMethods,
    },
    mounted(){
        
    },
}
</script>

<style lang="scss" scoped>
.page-card{
    max-height: 100%;
    .title-bar{
        z-index: 3!important;
    }
    .content-wrapper{
        overflow: hidden;

        .content-container{
            max-height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
        }
    }

}
</style>